<div class="form-check">
  <input type="checkbox" class="form-check-input" [id]="frame.inputId" [formControl]="frame.control" />
  <label class="form-check-label" [for]="frame.inputId">{{ label }}</label>
</div>
